import { render, staticRenderFns } from "./buddha-tablet.vue?vue&type=template&id=3a119767"
import script from "./buddha-tablet.vue?vue&type=script&lang=js"
export * from "./buddha-tablet.vue?vue&type=script&lang=js"
import style0 from "./buddha-tablet.vue?vue&type=style&index=0&id=3a119767&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports